import { array, DecoderType, object, record, string } from "decoders";
import { jsendResponseDecoder, jsendSuccessDecoder } from "Utils/jsend";
import { userDecoderKey } from "../auth/interfaces";

const creditorAccountSchema = object({
  name: string,
  accountNumber: string,
  bank: string,
});

const creditorAccountsDecoder = array(creditorAccountSchema);

export type CreditorAccounts = DecoderType<typeof creditorAccountsDecoder>;

export const creditorAccountResponseDecoder = jsendSuccessDecoder(creditorAccountsDecoder);

export type CreditorAccountResponse = DecoderType<typeof creditorAccountResponseDecoder>;

export const conciliationResponseDecoder = jsendResponseDecoder(userDecoderKey, record(array(string)));

export type ConciliationResponse = DecoderType<typeof conciliationResponseDecoder>;
